
const passwordRegex = /^[A-Za-z0-9@$!%*#?&]{6,16}$/
const userNameRegex = /^[A-Za-z0-9]{4,20}$/
const phoneRegex = /^[0-9]{11}$/


export {passwordRegex,userNameRegex,phoneRegex}